import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../components/comunes/ContenidoLogin.css";
import "./EntrarConZoco.css";
import zocoLogo from "../components/comunes/login-nuevo-assets/zoco-logo.png";
import SpinnerCarga from "../components/comunes/SpinnerCarga";
import { entrarConCodigoZoco } from "../helpers/entrarConCodigoZocoRequest";
import { setToken } from "../utils/auth";

// Lee codigo y volver de la URL una sola vez por instancia de componente. Si se leyeran
// de nuevo dentro del efecto, el segundo montaje de React 18 StrictMode los encontraria
// vacios: el primer montaje ya habria limpiado la barra de direcciones.
const leerParametrosDeAcceso = () => {
  const parametros = new URLSearchParams(window.location.search);
  return {
    codigo: parametros.get("codigo"),
    volver: parametros.get("volver"),
  };
};

const MENSAJE_SOLO_DUENO = "Solo el dueño puede entrar a Pagos.";
const MENSAJE_FALLO =
  "No pudimos entrar con tu cuenta de ZOCO. Ingresá con tu usuario y contraseña.";

/**
 * Canjea el codigo de acceso de un solo uso que manda el portal Zoco (?codigo=...&volver=...)
 * y deja a la persona logueada exactamente como el login con contraseña: mismo sessionStorage,
 * mismo reinicio completo de la app. Fase 2 de la unificación de cuentas Zoco/Pagos.
 */
const EntrarConZoco = () => {
  const [parametrosIniciales] = useState(leerParametrosDeAcceso);
  const [estado, setEstado] = useState("cargando");
  const navigate = useNavigate();

  const irALogin = useCallback(() => {
    navigate("/login");
  }, [navigate]);

  useEffect(() => {
    // Saca el codigo de un solo uso de la barra de direcciones apenas se lee, para que no
    // quede colgado ahi si la persona copia el link, recarga o lo comparte. Se preserva el
    // history.state existente (React Router v6 guarda ahi su {usr,key,idx}): pisarlo con
    // null deja el indice del router en null.
    window.history.replaceState(window.history.state, "", "/entrar");

    let cancelado = false;

    entrarConCodigoZoco(parametrosIniciales.codigo, parametrosIniciales.volver).then((resultado) => {
      if (cancelado) {
        return;
      }

      if (resultado.ok) {
        // Mismo sessionStorage que ContenidoLogin y mismo reinicio completo de la app:
        // replace no deja en el historial una entrada que apunte al codigo ya usado.
        setToken(resultado.token);
        window.location.replace(resultado.destino);
        return;
      }

      setEstado(resultado.motivo);
    });

    return () => {
      cancelado = true;
    };
  }, [parametrosIniciales]);

  return (
    <main className="login-page theme-minimal entrar-zoco-page">
      <header className="login-page__brand">
        <img src={zocoLogo} alt="Zoco" />
      </header>

      <section className="login-page__content" aria-live="polite">
        {estado === "cargando" && (
          <div className="entrar-zoco-page__estado">
            <p>Entrando a ZOCO Pagos…</p>
            <SpinnerCarga />
          </div>
        )}

        {estado === "solo_dueno" && (
          <div className="entrar-zoco-page__estado">
            <p className="login-form__error">{MENSAJE_SOLO_DUENO}</p>
            <button type="button" className="login-form__submit" onClick={irALogin}>
              Ingresar con usuario y contraseña
            </button>
          </div>
        )}

        {estado === "fallo" && (
          <div className="entrar-zoco-page__estado">
            <p className="login-form__error">{MENSAJE_FALLO}</p>
            <button type="button" className="login-form__submit" onClick={irALogin}>
              Ingresar con usuario y contraseña
            </button>
          </div>
        )}
      </section>
    </main>
  );
};

export default EntrarConZoco;
